import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import AuthActionPage from './components/AuthActionPage.tsx';

// /auth/action recebe os links dos e-mails do Firebase (redefinir senha, verificar e-mail...)
const isAuthAction = window.location.pathname.replace(/\/+$/, '') === '/auth/action';

// Limpeza única: a chave antiga de "atalho admin" não existe mais e nunca concedeu acesso por si só.
try { localStorage.removeItem('flowaes_admin_bypass'); } catch { /* sem armazenamento */ }

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      {isAuthAction ? <AuthActionPage /> : <App />}
    </React.StrictMode>
  );
}
